import React from "react"
import { graphql } from "gatsby"
import Teaser from "./Teaser"
import Video from "./Video"

import * as styles from "./videogroup.module.scss"

const VideoGroup = ({ title, description, cta, video }) => {
  const theme = video ? styles['innerVideo'] : styles['inner']
  const teaser = {}
  teaser.title = title ? title : undefined
  teaser.description = description ? description : undefined
  teaser.ctas = cta ? [cta] : undefined

  return (
    <section>
      <div className={theme}>
        <Teaser theme='basic' {...teaser} />
      </div>
      { video &&
      <Video video={video} />
      }
    </section>
  )
}

export default VideoGroup

export const query = graphql`
  fragment VideoGroupData on STRAPI__COMPONENT_SUPERCUSTOM_VIDEO_GROUP {
    title {
      copy
      header
    }
    description {
      type
      children {
        text
        type
      }
    }
    cta {
      label
      page {
        path
        title
      }
    }
    video {
      title
      youtube
      eyebrow
      thumbnail {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }  
      }
      transcript {
        type
        children {
          text
          type
        }
      }
      cta {
        label
        page {
          path
          title
        }
      }
      jumplink
      description {
        type
        children {
          text
          type
        }
      }
      doctor {
        name
      }
    }
  }
`
